var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center bg-gray-10 p-30"},[_c('bb-error-page',_vm._b({},'bb-error-page',_vm.content,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }